// Direct-owner (used) cars moved to dcar on 2026-10-02, so this app no longer shows them.
// The stock page's Direct Owner button opens dcar's user app in a new tab instead -
// dcar.redpeople.io on SIT, dcar.my in production, from REACT_APP_DCAR_URL.
//
// TO BRING DIRECT OWNER BACK: there is no switch. The removal is two commits,
//   fedbdac  "Direct Owner opens dcar, not a list here"
//   8e5cb04  "No Direct Owner or used cars anywhere in the user app"
// so `git revert 8e5cb04 fedbdac`, rebuild and upload. `git show <commit>` shows what was
// taken out. The API side is dc_backend commits df1aac5 and 3128f3d (see its CLAUDE.md).
export const DCAR_URL = process.env.REACT_APP_DCAR_URL || 'https://dcar.my'

export default function openDcar() {
  window.open(DCAR_URL, '_blank', 'noopener,noreferrer')
}
